export const CHANGE_HEADER = 'CHANGE_HEADER';
export const INIT_HEADER = 'INIT_HEADER';

export function changeHeader(options) {
    return { type: CHANGE_HEADER, options };
}

export function initHeader(options) {
    return { type: INIT_HEADER, options };
}

